import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RequirePermission } from "@/libs/guard/admin-permission-guard";

// Documents
const DocumentListPage = lazy(
  () => import("@/features/admin-view/documents/pages/document-list")
);
const DocumentDetailsPage = lazy(
  () => import("@/shared/documents/document-details")
);

export const documentsRoutes: RouteObject[] = [
  {
    path: "/admin/documents",
    element: (
      <RequirePermission resource="student-documents">
        <DocumentListPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/documents/:id",
    element: (
      <RequirePermission resource="student-documents">
        <DocumentDetailsPage />
      </RequirePermission>
    ),
  },
];
